import Vue from 'vue'
import { AutoTranslator } from '@transsion/hotent-ui'
import { MessageBox } from 'element-ui'
import i18n from '@/i18n'
import {
  DEFAULT_LANGUAGE,
  ZH_CODE,
} from '@transsion/hotent-ui/packages/Language'
const NOT_PROD = process.env.VUE_APP_ENV !== 'prod'

// import { francAll } from 'franc-min'

// TODO: 目前就支持这些，后续再扩展
// const FRANC_CODE_2_COUNTRY_TWO_CHARACTER_CODE = {
//   cmn: 'zh', // 简体中文
//   eng: 'en', // 英文
//   rus: 'ru', // 俄语
//   ind: 'id', // 印度尼西亚语
//   fra: 'fr', // 法语
// }

// let translateTo = 'en'

const translator = new AutoTranslator(document.body, {
  fromLocale: ZH_CODE, // 可选：源语言，默认为中文
  textMatcher: (text, from, defaultMatcher) => {
    return defaultMatcher(text, from)
    // text = text?.trim()

    // if (!text) return false

    // // 预测文本的语言
    // // 返回一个二维数组，第一项是语言代码，第二项是可信度
    // // 例如：[['cmn', 1], ['yue', 0.8], ['wuu', 0.6]]
    // // only: 只检测指定的语言
    // const predictiveLangs = francAll(text, {
    //   only: Object.keys(FRANC_CODE_2_COUNTRY_TWO_CHARACTER_CODE),
    //   minLength: 2,
    // })

    // // 是否存在翻译的目标语言
    // const isExistTargetLang = predictiveLangs.find((item) => {
    //   const [langCode, credibility] = item
    //   const countryCode = FRANC_CODE_2_COUNTRY_TWO_CHARACTER_CODE[langCode]

    //   // 目标语言在可信列表中，并且可信度大于0%
    //   return countryCode === translateTo && credibility > 0
    // })

    // // 可信列表中的语言就不需要翻译
    // if (isExistTargetLang) return false

    // const [langCode] = predictiveLangs[0]

    // return FRANC_CODE_2_COUNTRY_TWO_CHARACTER_CODE[langCode] !== translateTo
  },
  isTest: NOT_PROD,
})

// targetLang: en | id
export function checkTranslate(targetLang) {
  if (targetLang === DEFAULT_LANGUAGE) return

  // translateTo = targetLang

  const autoTranslate = localStorage.getItem('tr_auto_translate') === '1'

  if (autoTranslate) {
    translator.translateTo(targetLang)
  } else {
    MessageBox.confirm(
      i18n.t('autoTranslator.tips'),
      i18n.t('autoTranslator.hint'),
      {
        confirmButtonText: i18n.t('autoTranslator.confirm'),
        cancelButtonText: i18n.t('autoTranslator.cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }
    ).then(() => {
      localStorage.setItem('tr_auto_translate', '1')

      Vue.prototype.$baseEventBus.$emit('update_auto_translate')

      translator.translateTo(targetLang)
    })
  }
}

export function stopObserve() {
  translator.stopObserve()
}
